export default __webpack_public_path__ + "static/media/check.d837dc72.svg";